import { graphql, useStaticQuery } from "gatsby";
import * as React from "react";
import { Container } from "react-bootstrap";
import { getParagraph } from "../../../utils/paragraphHelpers";
import { footerBrandContainer } from "./Footer.module.scss";
import {
  CopyRight,
  CopyrightCol,
  CopyrightRow,
  FooterWrapper,
} from "./FooterHelpers";
import FooterLinks from "./FooterLinks/FooterLinks";
import { IFooterProps } from "./FooterProps";
import { useFooterSliceContext } from "../../../context/SliceContexts/FooterContext";
import BrandBar from "../BrandBar/BrandBar";

const Footer: React.FC<IFooterProps> = () => {
  const { location, showMerchandisingBlock } = useFooterSliceContext();
  const data = useStaticQuery(graphql`
    query {
      site: rlhsite(machine_name: { eq: "sonesta" }) {
        id
        relationships {
          footerItems: field_footer {
            type: __typename
            ...ParagraphFooterCta
            ...ParagraphMerchandisingBlock
            ... on paragraph__footer_item {
              field_footer_group
              field_footer_link {
                title
                url
              }
            }
          }
        }
      }
    }
  `);
  const _footerLinks = data.site.relationships.footerItems;
  const footerMerchandisingBlock = _footerLinks
    ? _footerLinks.map(getParagraph)
    : [];

  return (
    <FooterWrapper>
      <Container fluid="sm">
        <FooterLinks {..._footerLinks} />
        <hr className="d-none d-lg-block mt-4 mb-4" />

        <div className={footerBrandContainer}>
          <div className="icon-container">
            {/* {isMobileOnly ? (
              <>
                <a id="Travel-Pass-mobile" href="/travel-pass">
                  <svg className="sonesta-footer-logo mobile-view">
                    <title>Travel Pass Sonesta</title>
                    <use xlinkHref="/svg/footer/SonestaTravelPass.svg#TravelpassMobile"></use>
                  </svg>
                </a>
              </>
            ) : (
              <>
                <a id="Travel-Pass-desktop" href="/travel-pass">
                  <svg className="sonesta-footer-logo desktop-view">
                    <title>Travel Pass Sonesta</title>
                    <use xlinkHref="/svg/footer/Travelpass.svg#Travelpass"></use>
                  </svg>
                </a>
              </>
            )} */}
            <a id="sonesta-international-hotel" href="/">
              <svg
                className="sonesta-international-footer-logo"
                width={198}
                height={53}
              >
                <title>Sonesta International Hotels</title>
                <use xlinkHref="/svg/newFooterLogos/sonesta-international.svg#sonesta-international"></use>
              </svg>
            </a>
            <a id="sonesta-travel-pass" href="/travel-pass">
              <svg
                className="sonesta-travel-pass-footer-logo"
                width={177}
                height={35}
              >
                <title>Sonesta Travel Pass </title>
                <use xlinkHref="/svg/newFooterLogos/sonesta-travel-pass.svg#sonesta-travel-pass"></use>
              </svg>
            </a>
            <BrandBar footer={true} />
          </div>
        </div>

        <hr className="d-none d-lg-block mt-4 mb-4" />
        {showMerchandisingBlock !== undefined
          ? showMerchandisingBlock
            ? footerMerchandisingBlock
            : null
          : footerMerchandisingBlock}
        <hr className="d-none d-lg-block" />
        <CopyrightRow>
          <CopyrightCol>
            <CopyRight className="text-center text-lg-left">
              © {new Date().getFullYear()} Sonesta International Hotels
              Corporation. All Rights Reserved.
            </CopyRight>
          </CopyrightCol>
        </CopyrightRow>
      </Container>
    </FooterWrapper>
  );
};

export default Footer;
